import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

const isEmpty = (control: AbstractControl): boolean =>
  Validators.required(control) !== null;

const REGEX_DIGITS = /^\d+$/;
// Accepts integers and decimals, optionally with thousand-separator commas
const REGEX_NUMBER = /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/;
// eslint-disable-next-line max-len
const REGEX_URL = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;
const REGEX_CARD = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/;

export class CustomValidators {

  static email = Validators.email;
  static min = Validators.min;
  static max = Validators.max;
  // lte(n) ≡ max(n)
  static lte = Validators.max;

  static digits(control: AbstractControl): ValidationErrors | null {
    if (isEmpty(control)) { return null; }
    return REGEX_DIGITS.test(control.value) ? null : { digits: true };
  }

  static number(control: AbstractControl): ValidationErrors | null {
    if (isEmpty(control)) { return null; }
    return REGEX_NUMBER.test(control.value) ? null : { number: true };
  }

  static url(control: AbstractControl): ValidationErrors | null {
    if (isEmpty(control)) { return null; }
    return REGEX_URL.test(control.value) ? null : { url: true };
  }

  static creditCard(control: AbstractControl): ValidationErrors | null {
    if (isEmpty(control)) { return null; }
    const sanitized = String(control.value).replace(/[^0-9]+/g, '');
    if (!REGEX_CARD.test(sanitized)) { return { creditCard: true }; }
    // Luhn check
    let sum = 0;
    let shouldDouble = false;
    for (let i = sanitized.length - 1; i >= 0; i--) {
      let digit = parseInt(sanitized[i], 10);
      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) { digit -= 9; }
      }
      sum += digit;
      shouldDouble = !shouldDouble;
    }
    return sum % 10 === 0 ? null : { creditCard: true };
  }

  static notEqual(val: any): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (isEmpty(control)) { return null; }
      return control.value !== val ? null : { notEqual: true };
    };
  }
}
